import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { InventoryDashboardRoutingModule } from '@inventory/components/dashboard';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    InventoryDashboardRoutingModule,
    MaterialModule,
    SharedModule,
    LayoutModule
  ]
})
export class InventoryDashboardModule { }
